import React, { useState, useEffect, useCallback, ChangeEvent } from 'react'
import { Autocomplete, Button, TextField } from '@mui/material'
import { Container, Header, Form } from './styles'
import api, { operation } from '../../services/axios'
import { useSelector } from 'react-redux'
import { StoreState } from '../../store'
import { cnpjCpfMask, zipcodeMaks } from '../../utils/masks'
import axios from 'axios'
import { states, statesParse } from '../../utils/states'
import swal from 'sweetalert'
import { companyType } from '../../utils/companytype'
import { get } from 'lodash'
import * as yup from 'yup'

interface InstitutionData {
    cnpj_cpf: string
    fantasy_name: string
    invoicing: string | null
    address: string
    city: string
    complement: string
    district: string
    number: string
    email: string
    fone: string
}

const institutionInitial: InstitutionData = {
    cnpj_cpf: '',
    fantasy_name: '',
    invoicing: '',
    address: '',
    city: '',
    complement: '',
    district: '',
    number: '',
    email: '',
    fone: '',
}

// validar email async
const schema = yup.object().shape({
    cnpj_cpf: yup.string().required(),
    fantasy_name: yup.string().required().min(3).max(255),
    invoicing: yup.string(),
    address: yup.string().required().min(3).max(64),
    city: yup.string().required().min(3).max(64),
    complement: yup.string().min(0).max(64),
    district: yup.string().required().min(3).max(64),
    number: yup.string().required(),
    email: yup.string().required().email(),
    fone: yup.string().required().min(11).max(11),
    zipcode: yup.string().required().min(8).max(8),
    type: yup.string().required().min(3).max(64),
    state: yup.string().required(),
})

const Instituicao: React.FC = () => {
    const { cnpj_cpf } = useSelector((state: StoreState) => state.auth.user)
    const [institution, setInstitution] =
        useState<InstitutionData>(institutionInitial)
    const [zipcode, setZipcode] = useState('')
    const [type, setType] = useState('Selecione')
    const [state, setState] = useState('Selecione')
    // const [institution, setInstitution] = useState('')
    const getInstitutionData = useCallback(async () => {
        operation.attempt(async (currentAttempt) => {
            try {
                const { data } = await api.get(
                    `/minhaconta/institution/${cnpj_cpf}`
                )
                setInstitution({
                    cnpj_cpf: data.cnpj_cpf,
                    fantasy_name: data.fantasy_name,
                    invoicing: data.invoicing,
                    address: data.address.address,
                    city: data.address.city,
                    complement: data.address.complement,
                    district: data.address.district,
                    number: data.address.number,
                    email: data.contact.email,
                    fone: data.contact.fone,
                })
                setType(data.type)
                setState(data.address.state)

                setZipcode(data.address.zipcode)
            } catch (e: any) {
                // toast.error(erro)
                const status = get(e, 'response.status', '')
                // toast.error(erro)
                if (status === 401) {
                    if (operation.retry(e)) return
                }
            }
        })
    }, [cnpj_cpf])
    useEffect(() => {
        getInstitutionData()
    }, [getInstitutionData])

    useEffect(() => {
        if (zipcode.length !== 9) return

        async function getAdressByZipcode() {
            const zipcodeOnlyNumber = zipcode.replace(/\D/g, '')
            const response = await axios.get(
                `https://viacep.com.br/ws/${zipcodeOnlyNumber}/json/`
            )
            if (response.data.erro) return
            const { localidade, logradouro, bairro, uf } = response.data
            // setType(t => {
            //   return t
            // })
            setInstitution((inst) => {
                return {
                    ...inst,
                    city: localidade,
                    address: logradouro,
                    district: bairro,
                }
            })

            setState((prevState) => uf)
        }

        getAdressByZipcode()
    }, [zipcode])

    const sigla: keyof typeof statesParse = state as keyof typeof statesParse
    const estado = statesParse[sigla]

    function zipcodeChange(
        e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) {
        e.currentTarget.maxLength = 9
        setZipcode(e.target.value)
    }

    function handleChange(
        e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) {
        setInstitution({
            ...institution,
            [e.target.name]: e.target.value,
        })
    }

    async function validate() {
        // let erros = false

        if (!type || type === 'Selecione') {
            return false
        }

        if (!state || state === 'Selecione') {
            return false
        }

        const data = {
            ...institution,
            zipcode: zipcode.replace(/\D/g, ''),
            type,
            state,
        }
        const valid = await schema.isValid(data)
        return valid
    }

    async function handleSubmit() {
        try {
            // validar
            const isValid = await validate()
            if (!isValid) {
                swal({
                    title: 'Existem campos não preenchidos',
                    text: `Por favor, preencha todos os campos!`,
                    icon: 'error',
                })
                return
            }
            // const { data } = await api.get(`/validacao/email?email=${institution.email}`)
            // if(data) {
            //   toast.error('Email já em uso')
            //   return
            // }

            await api.put('/updateinst', {
                ...institution,
                zipcode: zipcode.replace(/\D/g, ''),
                state: state,
                type: type,
            })
            swal({
                title: 'Sucesso!',
                text: `Seu dados foram atualizados`,
                icon: 'success',
            })
        } catch (error) {
            swal({
                title: 'Erro!',
                text: `Não foi possível atualizar seus dados`,
                icon: 'error',
            })
        }
    }
    return (
        <Container>
            <Header>
                <div className="title">
                    <h2>Dados da instituição</h2>
                    <p>Atualize os dados da sua empresa aqui</p>
                </div>
                <div className="actions">
                    <Button onClick={handleSubmit} variant="contained">
                        Salvar
                    </Button>
                </div>
            </Header>

            <Form>
                <fieldset className="fieldset">
                    <div className="input-group">
                        <div className="input-wrapper">
                            <TextField
                                className="input"
                                name="fantasy_name"
                                label="Nome fantansia"
                                onChange={(e) => handleChange(e)}
                                value={institution?.fantasy_name}
                                id="fantasy_name"
                                variant="outlined"
                            />
                        </div>
                        <div className="input-wrapper">
                            <TextField
                                type="text"
                                className="input"
                                label="Cnpj ou Cpf"
                                name="cnpj_cpf"
                                disabled
                                onChange={(e) => handleChange(e)}
                                value={cnpjCpfMask(institution?.cnpj_cpf || '')}
                                id="cnpj_cpf"
                                variant="outlined"
                            />
                        </div>
                    </div>
                </fieldset>
                <fieldset className="fieldset">
                    <div className="input-group">
                        <div className="input-wrapper">
                            <TextField
                                className="input"
                                name="fone"
                                label="Telefone"
                                onChange={(e) => handleChange(e)}
                                value={institution?.fone}
                                id="fone"
                                variant="outlined"
                            />
                        </div>
                        <div className="input-wrapper">
                            <TextField
                                type="email"
                                className="input"
                                label="Email"
                                disabled
                                onChange={(e) => handleChange(e)}
                                name="email"
                                value={institution?.email}
                                id="email"
                                variant="outlined"
                            />
                        </div>
                    </div>
                </fieldset>

                <fieldset className="fieldset">
                    <div className="input-group">
                        <div className="input-wrapper">
                            <TextField
                                className="input"
                                label="Faturamento"
                                name="invoicing"
                                onChange={(e) => handleChange(e)}
                                value={institution?.invoicing}
                                id="invoicing"
                                variant="outlined"
                            />
                        </div>
                        <div className="input-wrapper">
                            {/* <TextField className='input' name='type' onChange={(e) => handleChange(e)} value={institution?.type} id="type" placeholder="Tipo da empresa" variant="outlined" /> */}
                            <Autocomplete
                                onChange={(event, newValue) =>
                                    setType(newValue?.label || 'Selecione')
                                }
                                disablePortal
                                value={{ label: `${type}` }}
                                isOptionEqualToValue={(option, value) => {
                                    return option.label === value.label
                                }}
                                id="companyType"
                                options={companyType}
                                sx={{
                                    width: '100%',
                                    fontFamily: 'Roboto',
                                    fontSize: '18px',
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Tipo da empresa"
                                    />
                                )}
                            />
                        </div>
                    </div>
                </fieldset>
                <fieldset className="fieldset">
                    <div className="input-group">
                        <div className="input-wrapper">
                            <TextField
                                className="input"
                                name="zipcode"
                                label="CEP"
                                onChange={(e) => zipcodeChange(e)}
                                value={zipcodeMaks(zipcode || '')}
                                id="zipcode"
                                variant="outlined"
                            />
                        </div>
                        <div className="input-wrapper">
                            <TextField
                                className="input"
                                name="address"
                                label="Endereço"
                                onChange={(e) => handleChange(e)}
                                value={institution?.address}
                                id="address"
                                variant="outlined"
                            />
                        </div>
                    </div>

                    <div className="input-group">
                        <div className="input-wrapper">
                            <TextField
                                className="input"
                                name="number"
                                label="Número"
                                onChange={(e) => handleChange(e)}
                                value={institution?.number}
                                id="number"
                                variant="outlined"
                            />
                        </div>
                        <div className="input-wrapper">
                            <TextField
                                className="input"
                                name="complement"
                                label="Complemento"
                                onChange={(e) => handleChange(e)}
                                value={institution?.complement}
                                id="complement"
                                variant="outlined"
                            />
                        </div>
                    </div>

                    <div className="input-group">
                        <div className="input-wrapper">
                            <TextField
                                className="input"
                                name="district"
                                label="Distrito"
                                onChange={(e) => handleChange(e)}
                                value={institution?.district}
                                id="district"
                                variant="outlined"
                            />
                        </div>
                        <div className="input-wrapper">
                            <TextField
                                className="input"
                                name="city"
                                label="Cidade"
                                onChange={(e) => handleChange(e)}
                                value={institution?.city}
                                id="city"
                                variant="outlined"
                            />
                        </div>
                        <div className="input-wrapper">
                            {/* <TextField className='input' name='state' onChange={(e) => handleChange(e)} value={estado} id="state" placeholder="Estado" variant="outlined" /> */}
                            <Autocomplete
                                onChange={(event, newValue) => {
                                    setState(newValue?.sigla || 'Selecione')
                                }}
                                isOptionEqualToValue={(option, value) => {
                                    return option.sigla === value.sigla
                                }}
                                value={{
                                    label: `${estado}`,
                                    sigla: `${state}`,
                                }}
                                disablePortal
                                id="city"
                                options={states}
                                sx={{
                                    width: '100%',
                                    fontFamily: 'Roboto',
                                    fontSize: '18px',
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Estado" />
                                )}
                            />
                        </div>
                    </div>
                </fieldset>
            </Form>
        </Container>
    )
}

export default Instituicao
